class Roulette
{
    constructor()
    {
        this.match = gsap.matchMedia();
        this.init();
    }

    init()
	{
        if(document.querySelector(".row_roulette .liste-mots")) {

            this.match.add("(min-width: 768px)", () => {

                // Clôner des mots pour remplir 1.5 fois la hauteur de la fenêtre, à activer au besoin
                // if(document.querySelector(".liste-mots").offsetHeight < window.innerHeight * 1.3) {
                //     let indexMot = 1;
                //     let indexMotMax = document.querySelectorAll(".liste-mots ul li").length;
                //     while(document.querySelector(".liste-mots").offsetHeight < window.innerHeight * 1.3) {
                //         let mot = document.querySelector(".liste-mots ul li:nth-child(" + indexMot + ")").cloneNode(true);
                //         document.querySelector(".liste-mots ul").appendChild(mot);
                //         indexMot++;
                //         if(indexMot > indexMotMax) {
                //             indexMot = 1;
                //         }
                //     }
                // }

                var h = document.querySelector(".row_roulette > div:first-child").offsetHeight/2;
                ScrollTrigger.create({
                    trigger:document.querySelector(".row_roulette > div:first-child"),
                    start: "top 50%-=" + h,
                    endTrigger: document.querySelector(".row_roulette > div:last-child"),
                    end: "bottom bottom",
                    //pinType:"fixed",
                    //pinReparent: true,
                    pin:true
                });
            });
    
            let mots = gsap.utils.toArray(".liste-mots li");
            mots.forEach(mot => {
                gsap.from(mot, {duration:0.8, x:150, ease:"power3.out",
                    scrollTrigger: {
                        scrub:1,
                        trigger:mot,
                        start:"top bottom",
                        end:"center center",
                        toggleActions: "restart pause resume reverse",
                    }
                });
                this.match.add("(min-width: 768px)", () => {
                    gsap.to(mot, {duration:0.8, alpha:0, ease:"power3.out",
                        scrollTrigger: {
                            scrub:1,
                            trigger:mot,
                            start:"top 25%",
                            end:"bottom 10%",
                            toggleActions: "restart pause resume reverse",
                        }
                    });
                });
            });
        }
	}
}

export default Roulette;